<sw-page class="topdata-login-attempt-log-list">
    <template #smart-bar-header>
        <h2>{{ $tc('TopdataContactLoginSW6.loginLog.list.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button variant="danger" @click="onClear">
            {{ $tc('TopdataContactLoginSW6.loginLog.list.buttonClear') }}
        </sw-button>
        <sw-button variant="primary" @click="onDownloadCsv">
            {{ $tc('TopdataContactLoginSW6.loginLog.list.buttonDownloadCsv') }}
        </sw-button>
        <sw-button variant="primary" @click="getList">
            {{ $tc('global.default.refresh') }}
        </sw-button>
    </template>

    <template #content>
        <div class="topdata-login-attempt-log-list__toolbar">
            <sw-text-field
                v-model="emailSearchTerm"
                class="topdata-login-attempt-log-list__search"
                size="small"
                :placeholder="$tc('TopdataContactLoginSW6.loginLog.list.searchEmailPlaceholder')"
                @input="onEmailSearchInput"
            >
                <template #prefix>
                    <sw-icon name="regular-search" size="16" />
                </template>
            </sw-text-field>

            <sw-select-field
                v-model="filterAttemptType"
                class="topdata-login-attempt-log-list__select"
                size="small"
                :options="attemptTypeOptions"
                @change="onFilterChanged"
            />

            <sw-select-field
                v-model="filterSuccess"
                class="topdata-login-attempt-log-list__select"
                size="small"
                :options="successOptions"
                @change="onFilterChanged"
            />
        </div>

        <sw-entity-listing
            v-if="items"
            :items="items"
            :repository="repository"
            :columns="columns"
            :isLoading="isLoading"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            detail-route="topdata.contact.login.attempt.log.detail"
            identifier="id"
            @page-change="onPageChange"
        >
            <template #column-attemptType="{ item }">
                <sw-badge variant="info">
                    {{ getAttemptTypeLabel(item.attemptType, item.contactId, item.customerId) }}
                </sw-badge>
            </template>

            <template #column-success="{ item }">
                <sw-badge :variant="getSuccessVariant(item.success)">
                    {{ getSuccessLabel(item.success) }}
                </sw-badge>
            </template>

            <template #column-errorMessage="{ item }">
                <template v-if="item.errorMessage">
                    <sw-badge variant="danger">
                        {{ getErrorMessageLabel(item.errorMessage) }}
                    </sw-badge>
                </template>
                <template v-else>
                    <span>—</span>
                </template>
            </template>

            <template #column-createdAt="{ item }">
                <sw-time-ago
                    :date="item.createdAt"
                    :date-time-format="{ month: '2-digit', day: '2-digit' }"
                />
            </template>
        </sw-entity-listing>

        <sw-modal
            v-if="showClearModal"
            :title="$tc('TopdataContactLoginSW6.loginLog.list.clearModalTitle')"
            variant="small"
            @modal-close="onCancelClear"
        >
            <p>{{ $tc('TopdataContactLoginSW6.loginLog.list.clearModalBody') }}</p>

            <template #modal-footer>
                <sw-button size="small" @click="onCancelClear">
                    {{ $tc('global.default.cancel') }}
                </sw-button>
                <sw-button variant="danger" size="small" @click="onConfirmClear">
                    {{ $tc('TopdataContactLoginSW6.loginLog.list.clearModalConfirm') }}
                </sw-button>
            </template>
        </sw-modal>
    </template>
</sw-page>
